import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { FiSearch } from "react-icons/fi";

import capitalize from "../../../utils/capitalize"

function Navbar() {
  const user = useSelector((state) => state.user.value);
  return (
    <NavbarContainer>
      <UserId>Welcome, {capitalize(user.firstname)} {capitalize(user.surname)}</UserId>
      <InputContainer>
        <Icon>
          <FiSearch />
        </Icon>
        <Input type="text" placeholder="Search for transactions" />
      </InputContainer>
    </NavbarContainer>
  );
}

const NavbarContainer = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start
  height: 8%;
  width: 50vw;
  min-width: 200px;
`;

const UserId = styled.h5`
  margin-bottom: 1rem;
  color: #0a0b69;
`;
const InputContainer = styled.div`
  display: flex;
  width: 100%;
`;

const Icon = styled.div`
  height: 3rem;
  width: 3rem;
  background-color: #dce4ff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
  svg {
    color: #555555;
  }
`;
const Input = styled.input`
  border: none;
  background-color: #e6e4ff;
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  color: #464646;
  width: 70%;

  &:focus {
    border: none;
    outline: none;
  }
`;

export default Navbar;
